import { render, staticRenderFns } from "./pageGoodSpecification.vue?vue&type=template&id=1623184a&scoped=true"
import script from "./pageGoodSpecification.vue?vue&type=script&lang=js"
export * from "./pageGoodSpecification.vue?vue&type=script&lang=js"
import style0 from "./pageGoodSpecification.vue?vue&type=style&index=0&id=1623184a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1623184a",
  null
  
)

export default component.exports